export const maintenancePageModel = {
    image_url: null,
    title: null,
    description: null,
    platforms: []
}